import React, { useState, useContext } from "react";
import BasicContext from '../BasicContext';
import { Picker, InputItem, List } from 'antd-mobile';


export function CountryFilter(props) {
  
  const { value, allowAll, onChange, disableAll } = props;
  
  const context = useContext(BasicContext);
  const countryList = context.countryList || [];
  
  const allCountry = disableAll ? [] : [{ Code: 'All', BrevityCode: 'EN', NameCn: '全部' }];

  const getOptions = (list) => {
    const result = (list || allCountry.concat(countryList)).map(item => {
      return {
        label: item.Code + ' - [' + item.BrevityCode + '] ' + item.NameCn,
        value: item.BrevityCode,
      };
    });

    if (allowAll) {
      result.unshift({ label: '不选择', value: '' });
    }

    return result;
  }

  const [countryOptions, setCountryOptions] = useState(getOptions());

  const onSearchChange = (v) => {
    const filterAccount = allCountry.concat(countryList)
      .filter(item => (item.NameCn + item.Name + item.Code + item.BrevityCode).toLowerCase()
        .indexOf((v + '').toLowerCase()) >= 0);
    const options = getOptions(filterAccount);
    setCountryOptions(options);

    // 理论上每搜索一下，再强制选中第一个
    if (options && options.length) {
      onChange([options[0].BrevityCode]);
    }
  }

  return <Picker
    extra="输入国家/地区搜索"
    title={<InputItem
      placeholder="请选择国家/地区"
      className="picker-search-input"
      style={{ width: "100%" }}
      clear={true}
      onChange={onSearchChange}
    />}
    data={countryOptions}
    value={value}
    cols={1}
    // cascade={false}
    onOk={e => {
      onChange(e)
    }}
  >
    <List.Item arrow="horizontal">国家/地区</List.Item>
  </Picker>
}
